var map = {
	"./af.json": 28002,
	"./am.json": 42699,
	"./ar.json": 67406,
	"./az.json": 43014,
	"./be.json": 33016,
	"./bg.json": 81002,
	"./bn.json": 82461,
	"./br.json": 2513,
	"./bs.json": 2582,
	"./ca.json": 75629,
	"./cs.json": 70371,
	"./cy.json": 88565,
	"./da.json": 46250,
	"./de.json": 48582,
	"./dv.json": 79895,
	"./el.json": 33580,
	"./en.json": 63390,
	"./es.json": 94101,
	"./et.json": 48244,
	"./eu.json": 26279,
	"./fa.json": 77776,
	"./fi.json": 53224,
	"./fr.json": 68605,
	"./ga.json": 11049,
	"./gl.json": 36138,
	"./ha.json": 75030,
	"./he.json": 538,
	"./hi.json": 20030,
	"./hr.json": 10439,
	"./hu.json": 53450,
	"./hy.json": 34670,
	"./id.json": 67384,
	"./is.json": 32433,
	"./it.json": 18888,
	"./ja.json": 94780,
	"./ka.json": 92341,
	"./kk.json": 74147,
	"./km.json": 86697,
	"./ko.json": 14223,
	"./ku.json": 40625,
	"./ky.json": 79405,
	"./lt.json": 3769,
	"./lv.json": 86399,
	"./mk.json": 34885,
	"./ml.json": 7588,
	"./mn.json": 58294,
	"./mr.json": 61522,
	"./ms.json": 2973,
	"./mt.json": 33084,
	"./nb.json": 52885,
	"./nl.json": 76719,
	"./nn.json": 26729,
	"./no.json": 25646,
	"./pl.json": 38501,
	"./ps.json": 67228,
	"./pt.json": 85533,
	"./ro.json": 36482,
	"./ru.json": 75416,
	"./sd.json": 57486,
	"./sk.json": 6299,
	"./sl.json": 75494,
	"./so.json": 2503,
	"./sq.json": 80685,
	"./sr.json": 25168,
	"./sv.json": 9804,
	"./sw.json": 46943,
	"./ta.json": 15546,
	"./tg.json": 96644,
	"./th.json": 52045,
	"./tk.json": 54000,
	"./tr.json": 35131,
	"./tt.json": 84705,
	"./ug.json": 21665,
	"./uk.json": 6749,
	"./ur.json": 64282,
	"./uz.json": 2146,
	"./vi.json": 81688,
	"./zh.json": 37815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21495;